import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Nav, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import searchOptions from './searchOptions';
import './MobileNav.css';

class MobileNav extends Component {
  isCurrentPath(linkPath) {
    return linkPath === this.props.currentPath;
  }

  getIndex() {
    return searchOptions.findIndex(searchOption => this.isCurrentPath(this.props.basePath + searchOption.path));
  }

  renderLinks(searchOptions) {
    return searchOptions.map(searchOption => {
      const linkPath = this.props.basePath + searchOption.path;
      const isCurrentPath = this.isCurrentPath(linkPath);
      return (
        <LinkContainer key={linkPath} to={linkPath}>
            
          <NavItem disabled={isCurrentPath}>
            {searchOption.title}
            <span className='expandIcon'>
              {isCurrentPath ? '-' : '+'}
            </span>
          </NavItem>
        </LinkContainer>
      );
    });
  }

  renderPre() {
    const pivotIndex = this.getIndex();
    const preOptions = searchOptions.filter((searchOption, i) => i <= pivotIndex);
    return this.renderLinks(preOptions);
  }

  renderPost() {
    const pivotIndex = this.getIndex();
    const postOptions = searchOptions.filter((searchOption, i) => i > pivotIndex);
    return this.renderLinks(postOptions);
  }

  render() {
    const className = 'MobileNav ' + (this.props.pre ? 'pre' : 'post');
    return (
      <Nav bsStyle="pills" className={className}>
        {this.props.pre ? this.renderPre() : this.renderPost()}
      </Nav>
    );
  }
}

MobileNav.propTypes = {
  pre: PropTypes.bool,
  basePath: PropTypes.string.isRequired,
  currentPath: PropTypes.string.isRequired,
};

export default MobileNav;



// WEBPACK FOOTER //
// ./src/components/search/searchNav/MobileNav.js